import { isAllowedNewsType } from "plos/src/utils/pulse";
import { newsImg, videoImgWrapper } from "./newsThumb.css";
import { NewsThumbProps } from "./types";

const NewsThumb = ({ imgWidth = 300, news, sizes }: NewsThumbProps) => {
  const { type, onDemandUrl } = news;

  if (!isAllowedNewsType(type) || !onDemandUrl) return null;

  const buildSrcSet = () =>
    [1, 2, 3, 4]
      .map((multiplier) => {
        const size = multiplier * imgWidth;
        return `${onDemandUrl}?width=${size} ${size}w`;
      })
      .join(", ");

  return (
    <div className={type === "video" ? videoImgWrapper : undefined}>
      <img
        srcSet={buildSrcSet()}
        src={`${onDemandUrl}?width=${imgWidth}`}
        sizes={sizes || `${imgWidth}px`}
        alt=""
        className={newsImg}
      />
    </div>
  );
};

export default NewsThumb;
